module.exports = __webpack_public_path__ + "img/0Q3A6078_FoamcoreMatted.3c6851d0.jpg";